import { Component, OnInit } from '@angular/core';
import { MatDialogRef} from '@angular/material';
import {isUndefined} from "util";
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var amplitude:any;


@Component({
  selector: 'new-manager-dialog',
  templateUrl: './new-manager.component.html',
  styleUrls: ['./new-manager-dialog.component.css']
})
export class NewManagerDialogComponent implements OnInit {

 managerName:string;
  groupEmpty:string;
  // description:string;
  failMsg:string;

  constructor(private restApiService:RestApiService,public newManagerDialogRef: MatDialogRef<NewManagerDialogComponent>,private toastyService:ToastyService, private toastyConfig: ToastyConfig) { }

  ngOnInit() {

  }

  onAdd()
  {
    this.failMsg = "";
    if (this.managerName == null || isUndefined(this.managerName) || this.managerName == "") {
      this.groupEmpty = "on-error";
      return;
    }
    else {
      this.restApiService.inviteManagerService(this.managerName).subscribe(
        result => {
          amplitude.getInstance().logEvent('AddbuttonclickedafterclickingonaddManagerbutton');
            // console.log(result);
          if (result.success != false) {
            var toastOptions:ToastOptions = {
              title: "Invitation Sent",
              msg: "Invitation was successfully sent to " + this.managerName +'. '+result.status,
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
            this.newManagerDialogRef.close(result);
          }
          else {
            this.failMsg = result.status;
          }

        });
    }
  }

  onDiscard()
  {
    amplitude.getInstance().logEvent('DiscardbuttonclickedafterclickingonaddManager');
    this.newManagerDialogRef.close({success:false});
  }
}



// WEBPACK FOOTER //
// ./src/app/manager/new-manager.ts